export const API_URL =
  process.env?.REACT_APP_API_URL ?? 'https://vatos-pas-api-dev.herokuapp.com';
export const ACCESS_TOKEN = 'accessToken';
